<template>
  <LandingBackground>
    <PublicLandingHeader
      :title="appSettingsStore.applicationTitle"
      subtitle="Nevada Division of Environmental Protection"
      light
    />

    <PublicLandingContainer class="grid justify-stretch md:justify-center 2xl:max-w-screen-2xl">
      <PublicLandingBackdrop class="2xl:col-span-2 grid grid-cols-1 2xl:grid-cols-2 gap-10" light>
        <PublicLandingOnlineServices
          class="2xl:col-span-2"
          title="Online Services"
          body="The Sustainability Management and Reporting Tool (SMART) offers online recycling and solid waste disposal reporting to the Bureau of Sustainable Materials Management."
        ></PublicLandingOnlineServices>
        <PublicLandingCard>
          <PublicLandingCardSection label="Recycling">
            <PublicLandingList>
              <PublicLandingListItem label="Submit annual recycling reports" />
              <PublicLandingListItem label="View historical recycled and diverted materials" />
              <PublicLandingListItem label="Secure access to your company or agency data" />
            </PublicLandingList>
          </PublicLandingCardSection>
        </PublicLandingCard>
        <PublicLandingCard>
          <PublicLandingCardSection label="Solid Waste Disposal">
            <PublicLandingList>
              <PublicLandingListItem label="Submit quarterly, semi-annual, and annual disposal reports" />
              <PublicLandingListItem label="View historical disposal data" />
              <PublicLandingListItem label="Secure access to your facility data" />
            </PublicLandingList>
          </PublicLandingCardSection>
        </PublicLandingCard>
      </PublicLandingBackdrop>
    </PublicLandingContainer>

    <MdrnFooter light black-and-white />
  </LandingBackground>
</template>

<script lang="ts">
import { MdrnFooter, useAppSettingsStore } from "@modernary/mui/components/common";
import { defineComponent } from "vue";
import {
  PublicLandingBackdrop,
  PublicLandingCard,
  PublicLandingCardSection,
  PublicLandingContainer,
  PublicLandingHeader,
  PublicLandingList,
  PublicLandingListItem,
  PublicLandingOnlineServices,
  PublicLandingParagraph,
} from "@modernary/mui/components/publicLanding";
import LandingBackground from "@/components/LandingBackground.vue";

// Home content for unauth'd users
export default defineComponent({
  name: "HomePublic",
  setup() {
    const appSettingsStore = useAppSettingsStore();

    return { appSettingsStore };
  },
  components: {
    MdrnFooter,
    PublicLandingCard,
    PublicLandingCardSection,
    PublicLandingList,
    PublicLandingListItem,
    PublicLandingParagraph,
    PublicLandingOnlineServices,
    PublicLandingHeader,
    PublicLandingContainer,
    PublicLandingBackdrop,
    LandingBackground,
  },
});
</script>

<style lang="css" module></style>
